window.Vivense = window.Vivense || {};

Vivense.validationUtil = (function ($) {

    var exports = {};

    function validateEmail(email){
        var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
        return re.test(decodeURIComponent($.trim(email)));
    }

    exports.validateEmail = validateEmail;

    return exports;
})(jQuery);
